const LOCALE = "en-GB";

const DATE_ONLY_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "numeric",
  month: "short",
  year: "numeric",
};

const DATE_LONG_OPTIONS: Intl.DateTimeFormatOptions = {
  ...DATE_ONLY_OPTIONS,
  month: "long",
};

const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  ...DATE_ONLY_OPTIONS,
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
};

const DATE_TIME_SECONDS_OPTIONS: Intl.DateTimeFormatOptions = {
  ...DATE_TIME_OPTIONS,
  second: "2-digit",
};

export function formatDateOnly(value: Date | string | number): string {
  const d = value instanceof Date ? value : new Date(value);
  return d.toLocaleDateString(LOCALE, DATE_ONLY_OPTIONS);
}

export function formatDateLong(value: Date | string | number): string {
  const d = value instanceof Date ? value : new Date(value);
  return d.toLocaleDateString(LOCALE, DATE_LONG_OPTIONS);
}

export function formatDateTime(value: Date | string | number): string {
  const d = value instanceof Date ? value : new Date(value);
  return d.toLocaleString(LOCALE, DATE_TIME_OPTIONS);
}

/** Like `formatDateTime` but includes seconds — for sub-minute-resolution views. */
export function formatDateTimeWithSeconds(value: Date | string | number): string {
  const d = value instanceof Date ? value : new Date(value);
  return d.toLocaleString(LOCALE, DATE_TIME_SECONDS_OPTIONS);
}

/** Compact "time ago" label: `just now`, `10min ago`, `6h ago`, `40d ago`. */
export function formatRelativeTime(value: Date | string | number): string {
  const d = value instanceof Date ? value : new Date(value);
  const minutes = Math.floor((Date.now() - d.getTime()) / 60_000);
  if (minutes < 1) return "just now";
  if (minutes < 60) return `${minutes}min ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}
